import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isoWeek from 'dayjs/plugin/isoWeek';
import 'dayjs/locale/tr';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
dayjs.locale('tr');

/**
 * The API stores and validates meeting times as Europe/Istanbul wall clock, so the calendar is
 * built in that zone regardless of where the coach's browser thinks it is.
 */
export const CALENDAR_TZ = 'Europe/Istanbul';

export function tz(value?: string | Date | Dayjs): Dayjs {
  return value ? dayjs(value).tz(CALENDAR_TZ) : dayjs().tz(CALENDAR_TZ);
}

/** Minutes since midnight, in calendar time. */
export function minutesOfDay(value: string | Date): number {
  const m = tz(value);
  return (m.hour() * 60) + m.minute();
}

/** "HH:mm" or "HH:mm:ss" to minutes since midnight. */
export function timeToMinutes(time: string): number {
  const [hours, minutes] = time.split(':');
  return (Number(hours) * 60) + Number(minutes);
}

export function minutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
}

/** Monday of the week the given day falls into. */
export function startOfWeek(value?: string | Date | Dayjs): Dayjs {
  return tz(value).startOf('isoWeek');
}

export function startOfMonth(value?: string | Date | Dayjs): Dayjs {
  return tz(value).startOf('month');
}

/** dayjs day() is 0 = Sunday, which matches the API's dayOfWeek. */
export function dayOfWeek(value: Dayjs): number {
  return value.day();
}

export function isSameDay(a: Dayjs, b: Dayjs): boolean {
  return a.format('YYYY-MM-DD') === b.format('YYYY-MM-DD');
}
